"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Accordion = _interopRequireDefault(require("01_core/components/layout/Accordion"));
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _KansaTgtJigyoBasicInfo = _interopRequireDefault(require("../../common/components/materials/KansaTgtJigyoBasicInfo"));
var _kansaResultActions = require("../kansaResultActions");
var _ShitekiJiko = _interopRequireDefault(require("./components/ShitekiJiko"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StyledReturnButton = (0, _styles.styled)(_CButton.default)({
  margin: '0 0 0 auto'
});
const StyledBlockSpace = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginTop: theme.spacing(1)
  };
});
class OldShitekiKaizenplanJissekiDisplay extends _react.default.Component {
  constructor(props) {
    super(props);

    // 監査結果画面から監査対象年度と監査対象事業IDを受け取る
    props.callAPI(_APIs.KANSA_RESULT_OLD_SHITEKI, props.kansaInfo).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        props.setShitekiList(response.data);
      } else {
        props.setShitekiList([]);
      }
    });
    // 監査対象基本情報取得
    props.callAPI(_APIs.KANSA_TGT_JIGYO_BASIC, props.kansaInfo).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        props.setKansaTgtJigyoBasicInfo(response.data);
      }
    });
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {
      intl,
      shitekiList,
      shitekiEntriesList,
      btnProps,
      kansaTgtJigyoBasicInfo,
      isNewWindow
    } = this.props;

    // 戻るボタン
    const returnButton = /*#__PURE__*/_react.default.createElement(StyledReturnButton, {
      onClick: isNewWindow ? btnProps.onClick : btnProps.onClick(false),
      autoWidth: true,
      negative: true
    }, btnProps.label);
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_SHITEKI_KAIZENPLAN_ZISSEKI_DISPLAY
      }),
      actions: [returnButton]
    }, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, shitekiList.length === 0 ?
    /*#__PURE__*/
    // 表示する情報がない場合
    _react.default.createElement(_material.Typography, null, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_NO_SHITEKI_KAIZENPLAN_ZISSEKI
    })) : /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true
    }, returnButton, /*#__PURE__*/_react.default.createElement(_KansaTgtJigyoBasicInfo.default, {
      data: kansaTgtJigyoBasicInfo
    }), shitekiList.map((item, index) => {
      const dispIndex = index + 1;
      return /*#__PURE__*/_react.default.createElement(StyledBlockSpace, {
        key: dispIndex
      }, /*#__PURE__*/_react.default.createElement(_Accordion.default, {
        title: intl.formatMessage({
          id: _labelConsts.LABEL.KANSA_SHITEKI_JIKO
        }) + dispIndex
      }, /*#__PURE__*/_react.default.createElement(_ShitekiJiko.default, {
        shitekiJiko: item,
        mode: _kansaResultActions.CONTENTS.SHITEKI_OLD_DETAIL,
        shitekiEntriesList: shitekiEntriesList,
        kansaTgtNendoNm: kansaTgtJigyoBasicInfo.kansaTgtNendoNm
      })));
    }))));
  }
}
const mapStateToProps = state => ({
  kansaInfo: state.kansaResult.kansaInfo,
  shitekiList: state.kansaResult.shitekiList,
  shitekiEntriesList: state.kansaResult.shitekiEntriesList,
  kansaTgtJigyoBasicInfo: state.kansaResult.kansaTgtJigyoBasicInfo
});
const mapDispatchToProps = dispatch => {
  return {
    setShitekiList: shitekiList => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_SHITEKI_LIST](shitekiList)),
    setKansaTgtJigyoBasicInfo: kansaTgtJigyoBasicInfo => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_KANSA_TGT_JIGYO_BASIC_INFO](kansaTgtJigyoBasicInfo))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(OldShitekiKaizenplanJissekiDisplay)));